import React from 'react'
import { LRX_41202_UC_IN_MARK_ALL_ITEM_FULFILLMENT } from '../../../../../../constants'
import { getFeatureFromCache } from '../../../../../../util/feature-cache'
import { Step3 } from './Step3'
import type { Step3Props } from './Step3'
import { Step3Legacy } from './Step3Legacy'

export const Step3Wrapper: React.FC<Step3Props> = props => {
  const isUnifiedMarkAllItemFulfillmentEnabled = getFeatureFromCache(
    LRX_41202_UC_IN_MARK_ALL_ITEM_FULFILLMENT
  )

  return isUnifiedMarkAllItemFulfillmentEnabled ? (
    <Step3 {...props} />
  ) : (
    <Step3Legacy {...props} />
  )
}

export { Step3Wrapper as Step3 }
export type { Step3Props }
